import { Flex, Box, Text, Button, Image } from 'rebass';
import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import useSWR from 'swr';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { useWindowSize } from 'react-use';
import milestonesPng from './assets/milestones.png';
import watchMeGrowPng from './assets/watchMeGrow.png';
import talkingFamilyTree from './assets/talkingFamilyTree.png';
import growthChartPreview from './assets/growth-chart-preview.png';
import { getSWR } from 'utils/api';
import { useCurrentMember } from 'members/hooks/index';

function FooterComponent({ disabled, sx = {}, backText = 'Back', onBackDisabled, onBack, nextButtonText, onStepUp, buttonSx = {} }) {
    return <Flex
        width="100%"
        sx={{
            justifyContent: "space-between",
            alignItems: "center",
            px: "26px",
            pt: 2,
            ...sx,
        }}
    >
        {onBack && <Flex
            height={40}
            justifyContent="space-around"
            alignItems="center"
            sx={{ borderRadius: 'medium', cursor: onBackDisabled || !onBack ? 'not-allowed' : 'pointer' }}
            onClick={onBackDisabled || !onBack ? undefined : onBack}
            disabled={onBackDisabled}
        >
            <Text as={IoIosArrowRoundBack} color="mineShaft" minWidth={"24px"} fontSize={24} />
            <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={2} fontWeight={400} fontSize="15px">
                {' '}
                {backText}
            </Text>
        </Flex>}

        <Button
            height={40}
            py={1}
            px={5}
            bg={disabled ? "grey" : "brand"}
            onClick={onStepUp}
            sx={{ borderRadius: '23px', marginTop: -120, zIndex: 1, opacity: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', ...buttonSx }}
        >
            {nextButtonText}
        </Button>
    </Flex>


}

const PaymentBlocker = ({ sku }) => {
    const modalRef = useRef(null);
    const { width } = useWindowSize();
    const { data } = useSWR(`/v3/shopify_products/${sku}`, getSWR);
    const attributes = data?.data?.data?.attributes
    const member = useCurrentMember();
    useEffect(() => {
        if (modalRef.current)
            modalRef.current.scrollTo(0, 0);
    }, []);
    const lDesc = attributes?.['long-description']

    function getSrc() {
        if (sku.includes("talkingfamilytree")) return talkingFamilyTree;
        if (sku.includes("milestones")) return milestonesPng;
        if (sku.includes("growthchart")) return growthChartPreview;
        return watchMeGrowPng;
    }

    function getPreviewTitle() {
        if (sku.includes("talkingfamilytree")) return 'A family tree that actually talks';

        if (sku.includes("milestones")) {
            return "Remember the Moments That Matter";
        }

        if (sku.includes("growthchart")) {
            return "A Beautiful Record of Their First Year of Growth";
        }

        return "Your Baby's Growth Story, Month by Month";
    }

    const renderStep = () => {
        return (
            <Flex m="auto" mt={width < 600 ? 0 : 2} flexDirection="column" justifyContent="center" alignItems="center" maxWidth={480}
                ref={modalRef}
                maxHeight={["80vh", "100%"]}
                overflow="auto" px={width < 600 ? 0 : 2} mb={7}>
                <Image src={getSrc()} />
                <Box px={width < 600 ? 2 : 0}>
                    <Text my="30px" color="#0E0E0E" fontFamily="Bitter" fontSize="30px" lineHeight="120%" letterSpacing="-0.18px">
                        {getPreviewTitle()}
                    </Text>
                    <Text sx={{
                        'div': {
                            maxWidth: '90vw !important',
                            m: 'auto'
                        }
                    }} dangerouslySetInnerHTML={{ __html: lDesc }} />
                    {lDesc && <FooterComponent
                        sx={{ justifyContent: 'center' }}
                        onStepUp={() => window.open(attributes?.['shopify-purchase-url'] + `?email=${encodeURIComponent(member?.email)}`, '_blank')}
                        nextButtonText="Buy now"
                    />}
                </Box>
            </Flex>
        );
    }

    return (
        <Box m={width < 600 ? 0 : 2} >
            {renderStep()}
        </Box>
    );
};

PaymentBlocker.defaultProps = {
    dividerText: 'other types',
    pagePosition: null,
};

PaymentBlocker.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default PaymentBlocker;
